module.exports = __webpack_public_path__ + "static/img/planet4.2c97634.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/he/planet/planet4.png
// module id = EG1U
// module chunks = 1